import { Capacitor } from '@capacitor/core';
import { App as CapApp } from '@capacitor/app';

// App version — dynamically loaded from build-generated version.json
// Fallback to static version if fetch fails (e.g., during development)
const FALLBACK_VERSION = '1.02';

let _cachedVersion = FALLBACK_VERSION;

// Try to load build-generated version on startup
try {
  fetch('/version.json')
    .then(r => r.ok ? r.json() : null)
    .then(data => { if (data?.version) _cachedVersion = data.version; })
    .catch(() => {}); // Silently fall back
} catch {}

export function getAppVersion() {
  return _cachedVersion;
}

export const APP_VERSION = FALLBACK_VERSION;

export async function getApkBuild() {
  if (!Capacitor.isNativePlatform()) return 0;
  try {
    const info = await CapApp.getInfo();
    return parseInt(info.build, 10) || 0;
  } catch {
    return 0;
  }
}
